import React from 'react'
import { cn } from '../../../lib/utils'

type Props = {
 title?: string
 subtitle?: string
 action?: React.ReactNode
 children: React.ReactNode
 className?: string
 contentClassName?: string
}

const AnalyticsPanel: React.FC<Props> = ({
 title,
 subtitle,
 action,
 children,
 className,
 contentClassName,
}) => (
  <div className={cn('dashboard-chart-card analytics-panel', className)}>
 {(title || subtitle || action) ? (
  <div
   className={cn(
    'flex flex-wrap items-center gap-3 border-b border-border-subtle bg-card px-5 py-4',
    title || subtitle ? 'justify-between' : 'justify-start',
   )}
  >
   {title || subtitle ? (
    <div className="min-w-0 text-start">
     {title ? <h6 className="text-sm font-semibold tracking-tight text-foreground">{title}</h6> : null}
     {subtitle ? (
      <p className={cn('text-xs text-muted-foreground', title && 'mt-0.5')}>{subtitle}</p>
     ) : null}
    </div>
   ) : null}
   {action ? (
    <div
     className={cn(
      'shrink-0',
      !(title || subtitle) && 'flex w-full flex-wrap items-center justify-start gap-2',
     )}
    >
     {action}
    </div>
   ) : null}
  </div>
 ) : null}
  <div className={cn('analytics-panel__content p-4 sm:p-5', contentClassName)}>{children}</div>
 </div>
)

export default AnalyticsPanel
